import React from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { BrowserRouter as Router } from 'react-router-dom';
import theme from './config/theme';
import { AdminProvider } from './context/AdminContext';
import AppRoutes from './routes/AppRoutes';

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AdminProvider>
        <Router>
          <AppRoutes />
        </Router>
      </AdminProvider>
    </ThemeProvider>
  );
};

export default App;
